<app-loader *ngIf="isLoading"></app-loader>
<app-header></app-header>
<app-breadcrumb></app-breadcrumb>
<div class="parallex" *ngIf="!isLoading">
    <div class="container">
        <div class="filter-container row">
            <div class="search-container col-xl-9 col-lg-8 col-md-12">
                <input type="text" placeholder="Search Here" [(ngModel)]="searchText" (keydown)="handleKeyDown($event)"
                    (keydown.enter)="searchApi()" class="search-box col-xl-12 col-lg-12 col-md-12">
                <span *ngIf="searchText !=null && searchText.length>0" class="crossIcon"
                    (click)="clearSearch()">X</span>
                <i class="search-icon" (click)="searchApi()"><img class="lensImage"
                        src="../../../../assets/images/searching-magnifying-glass.png"></i>
                <!-- Unicode for search icon -->
            </div>
            <div class="filter-category-container col-xl-3 col-lg-4 col-md-12">
                Filter By Category
                <div class="select-wrapper col-xl-12 col-lg-12 col-md-12">
                    <!-- <select [(ngModel)]="selectedCategory" (change)="applyFilters()" >
      <option value="">Select</option>
      <option *ngFor="let category of uniqueCategories" [value]="category.categoryType">{{ category.categoryType }}</option>
    </select> -->
                    <ng-select [(ngModel)]="selectedCategory" (change)="applyFilters()" [clearable]="false"
                        placeholder="Select">
                        <ng-option *ngFor="let category of uniqueCategories" [value]="category.categoryType">{{
                            category.categoryType }}
                        </ng-option>
                    </ng-select>
                    <span class="crossIconSelect" *ngIf="selectedCategory != null" (click)="clearSelect()">X</span>
                </div>
            </div>
        </div>

        <div class="container1 row">
            <ng-container *ngIf="cards.length==0">
                <div class="card-noItem col-xl-12 col-lg-12 col-md-12">
                    No Articles Found
                </div>
            </ng-container>
            <ng-container *ngIf="cards.length !=0">
                <div style="cursor: pointer;" *ngFor="let item of cards; trackBy: trackByFn" class="card col-xl-4 col-lg-6 col-md-12">
                    <img [src]="item.thumbnail" (click)="readMore(item)" alt="Card Image" class="card-img">
                    <span class="badge" (click)="readMore(item)">{{ item.articleCategoryType }}</span>
                    <h3 class="title" [title]="item.title" (click)="readMore(item)">{{ item.title }}</h3>
                    <p class="date" (click)="readMore(item)">{{ item.created_at | date }}&nbsp;&nbsp;
                        &nbsp;{{item.readTime || ''}}<ng-container *ngIf="item.readTime"> Read</ng-container></p>
                    <p class="description" (click)="readMore(item)">{{ removeHtmlTags(item.description) }}</p>
                    <a (click)="readMore(item)" class="read-more">Read More</a>
                </div>
            </ng-container>
        </div>
        <div class="loadMoreContainer">
            <button type="submit" *ngIf="displayLoadMore && cards.length !=0"
                class="btn saveProgress  btn-primary btn-block border-button" (click)="loadMore()">LOAD MORE</button>
        </div>
    </div>
</div>
<app-footer></app-footer>